<div>
    <h3 class="title" i18n="@@TeslaPayable" t="TeslaPayable">Confirmation of Tesla Business or Payable Location</h3>
    <table class="select-table" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="entityCountry">
            <th class="table-header-container" mat-header-cell *matHeaderCellDef>
                <div class="table-header" i18n="@@TeslaBusinessOrPayableLocation" t="TeslaBusinessOrPayableLocation">Tesla Business or Payable Location</div>
            </th>
            <td mat-cell *matCellDef="let element">
                <span>{{ translate.get(element.entityCountryName)}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="item">
            <th class="table-header-container" mat-header-cell *matHeaderCellDef>
                <div class="table-header"><span i18n="@@entityMappingItemHeader" t="entityMappingItemHeader">Please select your organization's details that can be used to conduct business with the listed Tesla Business or Payable Location.</span></div>
            </th>
            <td mat-cell *matCellDef="let element">
                <tsl-select #selectFields required [(ngModel)]="element.taskItem" (selectionChange)="onSelectChange()">
                    <tsl-option *ngFor="let option of getOptions(element.entityCountryName)" [value]="option.value">
                        {{ option.displayName }}
                    </tsl-option>
                </tsl-select>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <p class="error-message" *ngIf="showErrorMessage">{{ translate.get(errorMessage) }}</p>
</div>